import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { Form, Button } from "react-bootstrap";
import appConstants from "../constants/appConstants";
import Layout from "../components/Layout";

const getAuthToken = () => localStorage.getItem("authToken");

const EditContra = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [cashBankAccounts, setCashBankAccounts] = useState([]);
    const [contra, setContra] = useState({
        date: "",
        contra_number: "",
        from_account: "",
        to_account: "",
        from_account_id: "",
        to_account_id: "",
        amount: "",
        description: "",
    });

    useEffect(() => {
        fetchContra();
        fetchCashBankAccounts();
    }, []);

    const fetchContra = async () => {
        const token = getAuthToken();
        if (!token) return alert("Unauthorized! Please log in.");
        try {
            const response = await axios.get(`${appConstants.API_ROOT_URL}get-one-contra?id=${id}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setContra(response.data.contra);
        } catch (error) {
            console.error("Error fetching contra:", error);
        }
    };

    const fetchCashBankAccounts = async () => {
        const token = getAuthToken();
        if (!token) return alert("Unauthorized! Please log in.");
        try {
            const response = await axios.post(
                `${appConstants.API_ROOT_URL}get-accounts`,
                { account_type_ids: [9, 10] },
                { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } }
            );
            setCashBankAccounts(response.data.data);
        } catch (error) {
            console.error("Error fetching cash/bank accounts:", error);
        }
    };

    const handleAccountSelection = (e, type) => {
        const selectedAccount = cashBankAccounts.find(acc => acc.name === e.target.value);
        if (selectedAccount) {
            setContra({
                ...contra,
                [`${type}_account_id`]: selectedAccount.id,
                [`${type}_account`]: selectedAccount.name
            });
        } else {
            setContra({
                ...contra,
                [`${type}_account_id`]: "",
                [`${type}_account`]: e.target.value
            });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const token = getAuthToken();
        if (!token) return alert("Unauthorized! Please log in.");
    
        const payload = {
            contra_id: id,
            from_account_id: contra.from_account_id,
            to_account_id: contra.to_account_id,
            amount: parseFloat(contra.amount),
            date: contra.date,
            description: contra.description || "",
        };
    
        try {
            const response = await axios.post(`${appConstants.API_ROOT_URL}update-contra`, payload, {
                headers: { 
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            });
    
            alert(response.data.message || `Contra entry #${contra.contra_number} updated successfully!`);
            navigate("/contra-list");
        } catch (error) {
            console.error("Error updating contra:", error);
            alert(error.response?.data?.message || "Error updating contra. Please try again.");
        }
    };

    return (
        <Layout>
            <h4>Edit Contra</h4>
            <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-2">
                    <Form.Label>Date</Form.Label>
                    <Form.Control type="date" name="date" value={contra.date} onChange={(e) => setContra({ ...contra, date: e.target.value })} required />
                </Form.Group>

                <Form.Group className="mb-2">
                    <Form.Label>From Account</Form.Label>
                    <Form.Control list="cash-bank-accounts" value={contra.from_account} onChange={(e) => handleAccountSelection(e, "from")} />
                    <datalist id="cash-bank-accounts">
                        {cashBankAccounts.map(account => (
                            <option key={account.id} value={account.name}>{account.name}</option>
                        ))}
                    </datalist>
                </Form.Group>

                <Form.Group className="mb-2">
                    <Form.Label>To Account</Form.Label>
                    <Form.Control list="cash-bank-accounts" value={contra.to_account} onChange={(e) => handleAccountSelection(e, "to")} />
                </Form.Group>

                <Form.Group className="mb-2">
                    <Form.Label>Amount</Form.Label>
                    <Form.Control type="number" name="amount" value={contra.amount} onChange={(e) => setContra({ ...contra, amount: e.target.value })} required />
                </Form.Group>

                <Form.Group className="mb-2">
                    <Form.Label>Description</Form.Label>
                    <Form.Control type="text" name="description" value={contra.description} onChange={(e) => setContra({ ...contra, description: e.target.value })} />
                </Form.Group>

                <Button type="submit" variant="primary">Update Contra</Button>
                <Button variant="secondary" className="ms-2" onClick={() => navigate(-1)}>Cancel</Button>
            </Form>
        </Layout>
    );
};

export default EditContra;
